document.addEventListener('DOMContentLoaded', () => {

  const main = document.querySelector('#main');
  const menuButtons = document.querySelectorAll('[aria-controls=site-menu]');
  const menu = document.querySelector('.site-menu');
  const menuBg = document.querySelector('.site-menu__bg');
  const pages = document.querySelectorAll('.site-menu__list > li');
  const sectionBg = document.querySelector('.site-menu__section-bg');
  const searchButton = document.querySelector('[aria-controls=search]');
  const searchForm = document.querySelector('#header-search-form');
  const menuDelayCap = 70;
  var menuInterval = null;
  var menuDelay = 0;

  function isTouchDevice() {
    return Boolean(('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

  function isMenuOpen() {
    return main.classList.contains('is-menu-open') === true;
  }

  function closeMenu() {
    clearInterval(menuInterval);
    menuDelay = 0;
    main.classList.remove('is-menu-open');
    var menuButton = document.querySelector('.menu-toggle');
    menuButton.querySelector('.visually-hidden').innerHTML = 'Open';
    menu.setAttribute('aria-hidden', String(!isMenuOpen()));
    menu.hidden = !isMenuOpen();
    menuButton.setAttribute('aria-expanded', String(isMenuOpen()));
  }

  // When the escape key is pressed, close the menu.
  document.addEventListener('keydown', e => {
    if (isMenuOpen() && e.key === 'Escape') {
      closeMenu();
    }
  });

  // When the menu background is clicked, close the mnu.
  if (menuBg) {
    menuBg.addEventListener('click', (e) => {
      closeMenu();
    });
  }

  // Toggle search section
  if (searchButton) {
    searchButton.addEventListener('click', (e) => {
      const active = true;
      document.querySelector('.site-menu__list-item[data-id="search"] .site-menu__toggle').click();
      document.querySelector('.site-menu__search-form input').focus();
    });
  }

  // Menu toggle buttons
  menuButtons.forEach(menuButton => {

    menuButton.addEventListener('click', () => {
      main.classList.toggle('is-menu-open');
      if (isMenuOpen()) {
        menuButton.querySelector('.visually-hidden').innerHTML = 'Close';
      } else {
        menuButton.querySelector('.visually-hidden').innerHTML = 'Open';
      }
      menu.setAttribute('aria-hidden', String(!isMenuOpen()));
      menu.hidden = !isMenuOpen();
      menuButton.setAttribute('aria-expanded', String(isMenuOpen()));

    });

  });

  pages.forEach(el => {

    const toggle = (e) => {

      clearInterval(menuInterval);
      menuDelay = 0;
      if (e.target.parentNode.parentNode.getAttribute('aria-expanded') === 'true') {
        contract();
      } else {
        expand();
      }
      e.preventDefault();
      return false;

    };

    const contract = () => {

      main.classList.remove('is-menu-expanded');
      menu.classList.remove('is-expanded');

      pages.forEach(page => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });

      sectionBg.hidden = true;

    };

    const expand = () => {

      menuDelay = menuDelayCap;

      main.classList.add('is-menu-open');
      main.classList.add('is-menu-expanded');
      menu.classList.add('is-expanded');

      pages.forEach(page => {
        const active = page === el;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });

    };

    const hover = () => {
      sectionBg.hidden = false;
    };

    const hoverIf = (condition, e) => {
      if (condition(e)) {
        clearInterval(menuInterval);
        menuDelay = menuDelayCap;
        menuInterval = setInterval(() => {
          menuDelay -= 1;
          if (menuDelay <= 0) {
            if (e.target.parentNode.hasAttribute('aria-expanded')) {
              expand();
            } else {
              contract();
            }
          }
        }, 1);
      }
    };

    const leaveA = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const leave = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const expandIf = (condition, e) => {
      if (condition(e)) {
        if (isTouchDevice && e.target.closest('.site-menu__list-item').getAttribute('aria-expanded') == 'true') {
          return true;
        }
        expand();
        e.preventDefault();
      }
    };

    const expandHoverIf = (condition, e) => {
      if (condition(e) && (menuDelay <= 0 || !isMenuOpen()) ) {
        if (e.target.parentNode.hasAttribute('aria-expanded')) {
          expand();
        } else {
          contract();
        }
        e.preventDefault();
      }
    };

    const contractIf = (condition, e) => {
      clearInterval(menuInterval);
      menuDelay = 0;
      if (condition(e)) {
        contract();
        e.preventDefault();
      }
    };

    const expandIfMobile = expandIf.bind(undefined, e => {
      return isTouchDevice() && e.target.closest('.site-menu__list-item').hasAttribute('aria-expanded');
    });

    const hoverIfDesktop = hoverIf.bind(undefined, e => {
      return isTouchDevice() === false;
    });

    const expandHoverIfDesktop = expandHoverIf.bind(undefined, e => {
      return isTouchDevice() === false;
    });

    const contractIfDesktop = contractIf.bind(undefined, e => {
      return isTouchDevice() === false;
    });

    const back = el.querySelector('.site-menu__back');
    if (back) {
      back.addEventListener('click', (e) => {
        contract();
        e.preventDefault();
        return false;
      });
    }

    const closeButton = el.querySelector('.site-menu__close');
    if (closeButton) {
      closeButton.addEventListener('click', contract);
    }

    const toggleButton = el.querySelector('.site-menu__toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', toggle);
    }

    const a = el.querySelector(':scope > a');
    a.addEventListener('click', expandIfMobile);
    a.addEventListener('mouseenter', hover);
    a.addEventListener('mouseleave', leaveA);
    // a.addEventListener('focus', hover);
    menu.addEventListener('mouseleave', leave);

    a.addEventListener('mouseenter', hoverIfDesktop);
    a.addEventListener('mouseenter', expandHoverIfDesktop);

    contract();
  });

  // detect current sections and pages
  if (typeof currentPage !== 'undefined' && currentPage) {
    const page = document.querySelector('.page-nav a[data-id="' + currentPage + '"]');
    if (page) {
      page.classList.add('page-nav__link--active');
    }
    const link = document.querySelector('.site-menu__link--child[data-id="' + currentPage + '"]');
    if (link) {
      link.classList.add('site-menu__link--active');
    }
  }

  if (typeof currentSection !== 'undefined' && currentSection) {
    const section = document.querySelector('.site-menu__list-item[data-id="' + currentSection + '"]');
    const active = true;
    if (section && !isTouchDevice()) {
      section.setAttribute('aria-expanded', String(active));
      section.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
      section.querySelector(':scope > .site-menu__section').hidden = !active;
    }
    const link = document.querySelector('.site-menu__link--parent[data-id="' + currentSection + '"]');
    if (link) {
      link.classList.add('site-menu__link--active');
    }
  }

});
